import NameWithTitle from "../UI/NameWithTitle";
import i18n from "i18n";

const NameWithPrefixInput = ({ label = i18n.t("common:name"), placeholder = i18n.t("common:name"), id = null, required = true }) => (
  <NameWithTitle
    label={label}
    placeholder={placeholder}
    type="text"
    id={`${id ? id + "_" : ""}name`}
    autoComplete={`${id ? id + " " : ""}name`}
    required={required}
  />
);
export default NameWithPrefixInput;